import * as Events from '@core/events';
import * as utils from '@core/utils';
import { BUILD_EVENT } from '@core';
import { EEVents } from '@core/constants';

export const handler = ({
  form,
  field,
}: Pick<Events.TEventInformation<unknown>, 'form' | 'field'>) => {
  field.subscribe(
    BUILD_EVENT(EEVents.ON_SCOPE_CHANGE, 'configs', 'disable'),
    () => field.rehydrate(),
  );

  const { props = {} } = field.component;
  const staticInitialSchemaValue = props[field.mappings?.setValue] as
    | string
    | number;

  const groupValue =
    field.component.group &&
    utils.value.getValueByPath(form.initialValues, field.component.group);
  const initialValue =
    utils.value.getValueByPath(
      form.initialValues,
      groupValue === field.component.props?.value && !!groupValue
        ? field.component.group
        : field.component.name,
    ) || staticInitialSchemaValue;

  field.value =
    form.formData.form?.steps?.data[form.formData?.form?.steps?.index]
      ?.formatted[field.component.name] ||
    (!field.data.mounted ? initialValue : undefined);
  field.data.mounted = true;
};
